
import { getNews } from '@/common/js/api.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'


export default {
components: {
XHeader,
Box,
XButton,
Group,
CellBox,
Cell,
Scroller,
Icon,
VChart,
VTooltip,
VLine,
Flexbox,
FlexboxItem,
VScale
},
methods: {
getNews(newsId) {
let self = this
getNews({ data: { newsId: newsId } }).then(function(data) {
self.entity = data.Content
})
}
},
data() {
return {
entity: {}
}
},
created() {
let newsId = this.$route.query.newsId
this.getNews(newsId)
}
}



// WEBPACK FOOTER //
// ./src/components/love/Detail.vue